import { useEffect } from 'react'

import { getModalById, LOW_BALANCE_OFFER } from '#/features/modals'

import { LowBalanceOfferPlate } from './low-balance-offer-plate'


export const LowBalanceOfferOnStart = () => {
	const modal = getModalById(LOW_BALANCE_OFFER)

	useEffect(() => {
		modal.setState(true)
	}, [])

	return <LowBalanceOfferPlate />
}
